import React from "react";
import { color, motion } from "framer-motion";

const variants = {
  hover: {
    boxShadow: '0px 0px 20px 3px rgba(0, 0, 0, 0.2)', 
    scale: 1.03
  }
};

const iconInitialVariants = {
  initial: {
    opacity: 1
  },
  hover: {
    opacity: 0
  }
}

const iconHoverVariants = {
  initial: {
    opacity: 0
  },
  hover: {
    opacity: 1
  }
}

const CardWhyUs = ({
  title,
  text
}) => {
  return(
    <motion.div 
      className="card-why-us"
      initial="initial"
      whileHover="hover"
      variants={variants}
    >
        <div style={{ marginRight: '50px', position: 'relative' }}>
          <motion.i style={{ position: "absolute" }} variants={iconInitialVariants} className="bi bi-bookmark-check"></motion.i>
          <motion.i style={{ position: "absolute" }} variants={iconHoverVariants} className="bi bi-bookmark-check-fill"></motion.i>
        </div>
        <div>
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
    </motion.div>
  );
};

export default CardWhyUs;